var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modify-apply-block',{ref:"worker_edu_p",attrs:{"dataFileParm":{docName: '教育经历', isDoc: true},"data-type":"worker_edu","getEdit":_vm.getEdit,"saveEdit":_vm.saveEdit,"addEdit":_vm.addEdit,"form-parms-add":_vm.formParmsAdd,"block-name":"教育经历","is-absolut":true,"getTitle":_vm.getTitle,"ref-name":"worker_edu","worker-id":_vm.workerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }